import { AuthContext } from 'context/AuthContext';
import { FiltersContext } from 'context/GlobalFiltersContext';
import { React, useContext, useEffect, useState } from 'react';
import { AuthService, HeaderFilterService } from 'services/main';

const Amplifique = () => {
  const { authContext } = useContext(AuthContext);
  const { headerFiltersContext } = useContext(FiltersContext);
  const { user, token } = authContext;
  const { companies } = headerFiltersContext?.headerFilters;
  const email = user.id + '@userleankeep.com';
  const [companyType, setCompanyType] = useState();
  const [userType, setUserType] = useState();
  const [codeExecuted, setCodeExecuted] = useState(false);
  useEffect(() => {
    const styleTag = document.createElement('style');
    const script = document.createElement('script');
    let amplSurveyElement = null;

    if (!codeExecuted && companies) {
      styleTag.innerHTML = `
      .amp-icon-cancel:before {
        display: block !important;
      }

      `;

      HeaderFilterService.company(companies?.id).then(res => setCompanyType(res.data.tipoNome));
      AuthService.getUser({ id: user?.id, token }).then(res => setUserType(res.data.tipoNome));
      script.src = 'https://cdn.amplifique.me/amplifiqueme-inapp-survey.js';
      script.defer = true;
      script.onload = () => {
        if (!customElements.get('ampl-survey')) {
          customElements.define('ampl-survey', class extends HTMLElement {});
        }

        window.Amplifiqueme = {};
        window.Amplifiqueme.onLoad = () => {
          window.Amplifiqueme.identify(
            {
              email: email,
              created_at: user?.signUpUnixDate,
              name: user?.fullName,
              company: companies?.name,
              custom_fields: {
                nome_empresa: companies?.name,
                nome_usuario: user?.fullName,
                tipo_usuario: userType,
                segmento: companyType,
                idUsuario: user?.id,
                ehAdmin: user?.type === 'Operacional' ? 'True' : 'False',
                idEmpresa: String(companies?.id),
                plataforma: 'Web-Novo',
                nomeEmpresa: companies?.name,
                os: 'WEB',
              },
            },
            true,
          );
        };

        amplSurveyElement = document.createElement('ampl-survey');
        amplSurveyElement.setAttribute('identifier', '64286cc685cacdbcf60441ac');
        //amplSurveyElement.setAttribute('force', 'true');
        document.body.appendChild(amplSurveyElement);
        setCodeExecuted(true);
      };
      document.head.appendChild(styleTag);
      document.body.appendChild(script);
    }

    return () => {
      if (!codeExecuted && companies) {
        document.body.removeChild(script);
        //document.head.removeChild(styleTag);

        if (amplSurveyElement && amplSurveyElement.parentNode) {
          amplSurveyElement.parentNode.removeChild(amplSurveyElement);
        }
      }
    };
  }, [codeExecuted, companies, companies?.id, companies?.name, companyType, email, token, user, userType]);

  return <div></div>;
};

export default Amplifique;
